import React from "react";
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { ownerApi } from "../../../../api/owner";
import { formatApiError } from "../../../../api/client";

export default function OwnerChatGptExportDialog({ open, person, onClose }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    if (!open || !(person?.id || person?._id)) return;
    let cancelled = false;
    setLoading(true); setError(""); setData(null); setCopied(false);
    ownerApi.clientChatGptExport(person.id || person._id)
      .then((response) => !cancelled && setData(response.export))
      .catch((err) => !cancelled && setError(formatApiError(err, "No pude preparar la ficha para ChatGPT.")))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [open, person]);

  const copy = async () => {
    if (!data?.markdown) return;
    try { await navigator.clipboard.writeText(data.markdown); setCopied(true); }
    catch (_error) { setError("No pude copiar automáticamente. Seleccioná el texto y copialo manualmente."); }
  };
  const download = () => {
    if (!data?.markdown) return;
    const blob = new Blob([data.markdown], { type: "text/markdown;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `webprofit-${String(person?.name || "cliente").toLowerCase().replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "") || "cliente"}.md`;
    anchor.click();
    URL.revokeObjectURL(url);
  };

  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle sx={{ fontWeight: 1000 }}>Exportar ficha para ChatGPT</DialogTitle>
    <DialogContent>
      <Typography sx={{ color: "text.secondary", fontWeight: 700, fontSize: 13, mb: 1.2 }}>No envía información automáticamente. Genera una ficha para copiar/descargar y trabajar el cliente con el contexto real de WebProfit.</Typography>
      {loading ? <Box sx={{ py: 7, textAlign: "center" }}><CircularProgress /></Box> : null}
      {error ? <Alert severity="warning" sx={{ mb: 1 }}>{error}</Alert> : null}
      {data ? <Stack spacing={1.1}>
        <Alert severity="info"><strong>Recomendación WebProfit:</strong> {data.recommendation}</Alert>
        <TextField multiline fullWidth minRows={18} maxRows={28} value={data.markdown || ""} InputProps={{ readOnly: true }} />
      </Stack> : null}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.2 }}><Button onClick={onClose}>Cerrar</Button><Button startIcon={<DownloadRoundedIcon />} onClick={download} disabled={!data}>Descargar .md</Button><Button variant="contained" startIcon={<ContentCopyRoundedIcon />} onClick={copy} disabled={!data}>{copied ? "Copiado" : "Copiar para ChatGPT"}</Button></DialogActions>
  </Dialog>;
}
